export default __webpack_public_path__ + "static/media/107.1973d3ad.jpg";